export * from "./dataType";

import userinfo from "./userinfo/index";
import home from "./home/index";
import developers from "./tutorial/developers";
import termsOfApi from "./termsOfApi";
import termsOfSdk from "./termsOfSdk";
import apiKey from "./tutorial/apiKey";
import oAuth from "./tutorial/oAuth";
import guidelines from "./guidelines";
import termsOfService from "./termsOfService";
import guidelinesOfSdk from "./guidelinesOfSdk";

const staticData = {
  userinfo,
  home,
  developers,
  termsOfApi,
  termsOfSdk,
  apiKey,
  oAuth,
  guidelines,
  termsOfService,
  guidelinesOfSdk,
};

export default staticData;
